/**
 * Attention
 * Be aware that this module is dependent on support for Element.prototype.closest
 * This is included as default in https://polyfill.io/v3/polyfill.min.js
 */

// Used keycodes
const keycode = {
    arrowUp: 38,
    arrowDown: 40,
    home: 36,
    end: 35
};

const accordionSelector = '[data-action="accordion"]';

function openAccordion(trigger, content) {
    content.style.height = `${content.scrollHeight}px`;

    content.addEventListener('transitionend', function(e) {
        if (e.propertyName === 'height') {
            content.style.height = null;
        }
    });

    content.setAttribute('aria-hidden', false);
    trigger.setAttribute('aria-expanded', true);
}

function closeAccordion(trigger, content) {
    content.style.height = `${content.scrollHeight}px`;

    setTimeout(() => {
        content.style.height = '0';
    }, 0);

    content.setAttribute('aria-hidden', true);
    trigger.setAttribute('aria-expanded', false);
}

function openAccordByHashId() {
    if (window.location.hash.indexOf('accordion') > -1) {
        const content = document.getElementById(window.location.hash.replace('#', ''));

        if (content) {
            const accordion = document.getElementById(content.getAttribute('aria-labelledby'));
            accordion.click();
        }
    }
}

function toggleAccordion(e) {
    if (e && !(e.ctrlKey || e.metaKey || e.shiftKey)) {
        e.preventDefault();
    }

    const trigger = e.currentTarget;
    const accordion = trigger.closest(accordionSelector);

    if (accordion) {
        const content = accordion.querySelector('[aria-labelledby]');
        const opened = trigger.getAttribute('aria-expanded') == 'true';

        if (opened) {
            closeAccordion(trigger, content);
        } else {
            openAccordion(trigger, content);
        }
    }
}

function setupAccordion(accordionTrigger) {
    accordionTrigger.addEventListener('click', toggleAccordion);
}

/**
 * Initialise Accordions with this function
 * Will only run if given selector elements are found in DOM
 */
export function setupAccordions() {
    const accordions = document.querySelectorAll(accordionSelector);

    if (accordions) {

        accordions.forEach(accordion => {
            const accordionTrigger = accordion.querySelector('[aria-controls]');

            if (accordionTrigger) {
                setupAccordion(accordionTrigger);
            }
        });

        openAccordByHashId();
    }
}

window.addEventListener('keydown', event => {
    const focusedElement = document.activeElement;
    const closestElement = focusedElement.closest(accordionSelector);

    if (focusedElement && closestElement) {

        // Focus previous accordion
        if (event.keyCode === keycode.arrowUp) {
            const newFocusedElement = closestElement.previousElementSibling;
            if (newFocusedElement && newFocusedElement.querySelector('[aria-controls]')) {
                newFocusedElement.querySelector('[aria-controls]').focus();
            }
        }

        // Focus next accordion
        if (event.keyCode === keycode.arrowDown) {
            const newFocusedElement = closestElement.nextElementSibling;
            if (newFocusedElement && newFocusedElement.querySelector('[aria-controls]')) {
                newFocusedElement.querySelector('[aria-controls]').focus();
            }
        }

        // Focus first accordion
        if (event.keyCode === keycode.home) {
            const newFocusedElement = closestElement.parentNode.querySelector(`${accordionSelector}:first-child`);
            if (newFocusedElement && newFocusedElement.querySelector('[aria-controls]')) {
                event.preventDefault();
                newFocusedElement.querySelector('[aria-controls]').focus();
            }
        }

        // Focus last accordion
        if (event.keyCode === keycode.end) {
            const newFocusedElement = closestElement.parentNode.querySelector(`${accordionSelector}:last-child`);
            if (newFocusedElement && newFocusedElement.querySelector('[aria-controls]')) {
                event.preventDefault();
                newFocusedElement.querySelector('[aria-controls]').focus();
            }
        }
    }
});
